<template>
    <v-dialog fullscreen v-model="showLogin" persistent>
        <v-card height="100%" class="d-flex align-center" style="overflow-x: hidden">
            <v-row>
                <v-col lg="4" offset-lg="4" xs="12">
                    <v-card-title class="headline" primary-title>
                        Reset Password
                    </v-card-title>
                    <v-card-text v-if="!resetSuccess">
                        <v-layout>
                            <v-flex xs12>
                                <v-form v-model="valid" action="login">
                                    <v-text-field outlined
                                                  label="Enter your password"
                                                  :hint="getHint('password1')"
                                                  v-model="password1"
                                                  min="8"
                                                  :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                                                  @click:append="() => (passwordVisible = !passwordVisible)"
                                                  :type="passwordVisible ? 'password' : 'text'"
                                                  counter
                                    ></v-text-field>
                                    <v-text-field outlined
                                                  label="Re-enter your password"
                                                  :hint="password2 === password1 ? '' : 'Passwords must match'"
                                                  v-model="password2"
                                                  min="6"
                                                  :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                                                  @click:append="() => (passwordVisible = !passwordVisible)"
                                                  :type="passwordVisible ? 'password' : 'text'"
                                                  counter
                                    ></v-text-field>
                                </v-form>
                            </v-flex>
                        </v-layout>
                        <v-btn :disabled="!canSubmit" block color="primary" @click.stop="doSubmit">
                            <span>Submit</span>
                        </v-btn>
                    </v-card-text>
                    <v-card-text v-if="resetSuccess">
                        <v-alert outlined color="success" icon="mdi-check-circle" :value="true">
                            Your password was successfully reset.
                        </v-alert>
                        <v-btn depressed to="login" color="primary" dark block>Login</v-btn>
                    </v-card-text>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
  import {auth} from 'firebase'
  import gx from 'vue'

  export default {
    name: 'ResetPassword',

    mounted() {
      console.dir(this.$router);
      this.actionCode = this.$router.currentRoute.query.oobCode;
    },

    computed: {
      canSubmit() {
        if (this.getHint().length > "")
          return false

        if (this.password1 === "" || this.password2 === "")
          return false;

        if (this.password1 !== this.password2)
          return false;

        return true
      },
      isLongEnough() {
        return this.password1.length > 7
      },
      hasUpperAndLowerCase() {
        return this.password1.match(/[A-Z]/)
      },
      hasNumber() {
        return this.password1.match(/\d/)
      },
      hasSpecialCharacter() {
        return this.password1.match(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/)
      }
    },

    data() {
      return {
        passwordVisible: true,
        actionCode: '',
        showLogin: true,
        password1: '',
        password2: '',
        resetSuccess: false
      }
    },

    methods: {
      getHint() {
        var retStr = "";

        if (!this.isLongEnough)
          retStr += "Min. 8 characters,";

        if (!this.hasNumber)
          retStr += "Includes a number,";

        if (!this.hasUpperAndLowerCase)
          retStr += "UPPER and lower case,";

        if (!this.hasSpecialCharacter)
          retStr += "Special Character";

        return retStr
      },
      doSubmit() {
        // Verify the password reset code is valid.
        let fireAuth = auth();
        fireAuth.verifyPasswordResetCode(this.actionCode).then((email) => {
            fireAuth.confirmPasswordReset(this.actionCode, this.password1).then((resp) => {
              this.resetSuccess = true;
            }).catch(function (error) {
              console.dir(error)
              alert("Unknown Error")
            });
          }
        ).catch(function (error) {
          // Invalid or expired action code. Ask user to try to reset the password
          // again.
        });
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .valid {
        color: green;
    }

    .invalid {
        color: red;
    }
</style>
